<!-- 修改密码弹框 -->
<template>
<div class='container'>
	<el-dialog title="机构管理员账号（手机号）更改密码" :visible.sync="dialogVisible" width="25%" center class="el-dialog3">
			<div class="line1Box">
				<p class="p1"><span>*</span>旧登录密码</p>
				<el-input size="small" style="width: 2rem;" placeholder="验证旧密码"></el-input>
			</div>
			<div class="line1Box">
				<p class="p1">新登录密码</p>
				<el-input size="small" style="width: 2rem;" placeholder="请设置新密码"></el-input>
			</div>
			<div class="line1Box">
				<p class="p1">再次输入登录密码</p>
				<el-input size="small" style="width: 2rem;" placeholder="请再次输入新密码"></el-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="btns4" plain @click="dialogVisible = false">确定更换密码</el-button>
				<p style="font-size: 0.12rem;color: #424E5B;">忘记密码</p>
			</span>
		</el-dialog>
</div>
</template>

<script>

export default {
components: {},
data() {
return {
	dialogVisible: false,

}
},
computed: {},
watch: {},
methods: {
    init() {
        this.dialogVisible = true
    }
},
created() {

},
mounted() {

},
}
</script>
<style lang='scss' scoped>
.el-dialog3 {
    .btns4 {
			color: white;
			text-align: center;
			background: #ff6637;
			border-color: #ff6637;
			margin-bottom: 0.08rem;
		}
		.line1Box {
			display: flex;
			align-items: center;
			margin-top: 0.24rem;

			.btns5 {
				width: 1rem;
				height: 0.35rem;
				background: #3a62d7;
				font-size: 0.14rem;
				color: white;
				line-height: 0.35rem;
				text-align: center;
				margin-right: 0.1rem;
				cursor: pointer;
				margin-right: 0.2rem;
			}

			.p1 {
				font-size: 0.16rem;
				width: 1.5rem;
				position: relative;

				span {
					color: red;
					position: absolute;
					left: -8px;
					top: 0;
				}
			}
		}
	}
</style>